module.exports = __webpack_public_path__ + "static/media/logo-small.df3a02c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-small.svg
// module id = ./src/assets/logo-small.svg
// module chunks = 1